import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './assets/style/colors.css';
import './assets/style/base.css';

import DriverIndexApp from './components/root_app/driver_index_app.tsx';
import { createHashRouter, RouterProvider } from 'react-router';
import DriverPage from './components/pages/driver_page/driver_page.tsx';
import DriverList from './components/pages/driver_list/driver_list.tsx';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DI_FETCH_ON_FOCUS } from './config/constants.ts';
import { AzureAuthProvider } from './contexts/azure_auth_provider.tsx';
import { AzAuthCallBack } from './components/pages/auth_callback/AzAuthCallback.tsx';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: DI_FETCH_ON_FOCUS,
            gcTime: 1000 * 60 * 15, // 15 minutes
        },
    },
});

const router = createHashRouter([
    {
        path: '/',
        Component: DriverIndexApp,
        children: [
            {
                index: true,
                element: <DriverList />,
            },
            {
                path: 'driver/:driverId',
                element: <DriverPage />,
            },
            {
                path: 'auth/callback',
                element: <AzAuthCallBack />,
            },
        ],
    },
]);

createRoot(document.getElementById('app_root')!).render(
    <StrictMode>
        <AzureAuthProvider>
            <QueryClientProvider client={queryClient}>
                <RouterProvider router={router} />
            </QueryClientProvider>
        </AzureAuthProvider>
    </StrictMode>,
);
